import { SuggestedUsers } from "../../pages/HomePage/HomeComponents/SuggestedUsers";
import "./RightSideDiv.css";
export function RightSideDiv(){

    return(
        <>
            <div className="right-div">
                    
                    <SuggestedUsers />
                    
                </div>
        </>
    );
}